export default function data(
  state = {
    loading: true,
    modalMenu: false,
    token: '',
    company: {},
    user: null,
    categories: [],
    payments: [],
  },
  action
) {
  switch (action.type) {
    case '@data/LOAD': {
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    }

    case '@data/LOADING': {
      return {
        ...state,
        loading: !state.loading,
      };
    }

    case '@data/MENU': {
      return {
        ...state,
        modalMenu: !state.modalMenu,
      };
    }

    default:
      return state;
  }
}
